export default (template, values) =>
  template.replace(/\{(\w+)\}/g, (_, key) => values[key] ?? "");
